module.exports = __webpack_public_path__ + "static/media/icon-settings-google-analytics.adb6760d.svg";